import script from "./GuestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestForm.vue?vue&type=script&setup=true&lang=js"

import "./GuestForm.vue?vue&type=style&index=0&id=94bbd474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94bbd474"]])

export default __exports__